import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { AnalyticsRoot } from './components/AnalyticsRoot';
import { EstudiosEconomicos } from './pages/EstudiosEconomicos';
import { Layout } from './layouts/Layout';
import { ErrorBoundary } from './components/ErrorBoundary';

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <AnalyticsRoot />
      <ErrorBoundary>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Navigate to="/informe_estudios_economicos" replace />} />
            <Route path="/informe_estudios_economicos" element={<EstudiosEconomicos />} />
          </Route>
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
export default App;
